module.exports = __webpack_public_path__ + "img/message.0f3bbdea.svg";